import { Component } from "@angular/core";
import { GlobalApp, AuthorizationStatus } from "../../tools/global";
import {
  AccountService,
  InteractivesService,
  SubscriptionService,
  AdminInteractiveService,
  InteractSubTypesService,
  AdminInteractiveSubService,
  SubPeriodTypesService,
  AdminXmlaSubscriptionService,
} from "../../api/services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router, ActivatedRoute } from "@angular/router";
import {
  DropDownItem,
  ManagedSubscription,
  InteractSubTypes,
  InteractSubLevels,
  SubPeriodTypes,
  InteractSubType,
  InteractSubPrice,
  XmlaSubscriptionType,
  XmlaSubscriptionLevelEx,
  XmlaSubscriptionPriceEx,
  XmlaSubscriptionTypeEx,
  XmlaSubscriptionPrice,
  SubscriptionPurchaseViewModel,
  Users,
} from "../../api/models";
import { LoginLocal } from "../../api/models/login-local";
import { Observable, interval, observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { MessageDialogComponent } from "../../dialogs/message-dialog/message-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SubscriptionRenewViewModel } from "../../api/models/subscription-renew-view-model";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-home",
  templateUrl: "./update-subscription.component.html",
  styleUrls: ["./update-subscription.component.css"],
})
export class UpdateSubscriptionComponent {
  doneLoading: boolean = false;
  renewingSubscription: boolean = false;
  subscriptionId: number = 0;
  couponCode: string = "";
  orderPrice: number = 0;
  orderDiscount: number = 0;
  orderSalesTax: number = 0;
  orderTotalDue: number = 0;
  orderPaymentMethod: string = "CreditCard";
  poNumber: string = "";
  autoRenew: boolean = false;
  ccNumber: string = "";
  ccExpirationMonth: string = "";
  ccExpirationYear: string = "";
  ccCvv: number = 0;

  processingCreditCard: boolean = false;
  donePurchasing: boolean = false;
  allowInvoice: boolean = true;

  managedSubscription: ManagedSubscription = null;
  activatingSubscription: boolean = false;

  couponCodeError: string = "";

  authStatus: AuthorizationStatus = {
    isValid: false,
    userId: "",
    authToken: "",
    isAdmin: false,
  };

  payPalUrl: SafeResourceUrl = null;

  ccAvailableMonths: string[] = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  ccAvailableYears: string[] = [];

  isLoading: boolean = true;

  constructor(
    private app: GlobalApp,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer
  ) {
    var currentYear = new Date().getFullYear();
    for (var i = currentYear; i < currentYear + 15; i++) {
      let y = i.toString();
      this.ccAvailableYears.push(y.substr(2, 2));
    }

    this.ccExpirationMonth = this.ccAvailableMonths[0];
    this.ccExpirationYear = this.ccAvailableYears[0];

    this.payPalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://google.com"
    );

    app.getAuthorizationStatus().subscribe((result) => {
      this.authStatus = result;
    });

    this.route.paramMap.subscribe((params) => {
      var updateType = params.get("updateType");
      this.subscriptionId = parseInt(params.get("subscriptionId"));

      if (updateType == "Renew") {
        this.renewingSubscription = true;
      } else if (updateType == "Activate") {
        this.activatingSubscription = true;
        this.autoRenew = true;
      }

      this.subscriptionService
        .subscriptionGetManagedSubscriptions()
        .subscribe((result) => {
          for (var i = 0; i < result.length; i++) {
            if (result[i].subscriptionId == this.subscriptionId) {
              this.managedSubscription = result[i];
              this.autoRenew = true;
              this.doneLoading = true;
              this.allowInvoice = result[i].allowInvoice;

              this.isLoading = false;

              this.orderPrice = this.orderTotalDue = this.managedSubscription.totalDue;
              break;
            }
          }
        });
    });


  }

  validateForm(): boolean {
    if (
      this.orderPaymentMethod === "CreditCard" &&
      (this.ccNumber == null ||
        this.ccNumber == "" ||
        this.ccExpirationMonth == null ||
        this.ccExpirationYear == null ||
        this.ccCvv == null)
    ) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error Processing",
        "CC Number, Expiration Month / Year, and CVV are required."
      );
      return false;
    }

    if (
      this.orderPaymentMethod === "Invoice" &&
      (this.poNumber == null || this.poNumber.trim() == "")
    ) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error Processing",
        "PO Number is Required"
      );
      return false;
    }

    return true;
  }

  getCouponOrPeriod() {
    this.couponCodeError = "";

    var req: SubscriptionService.SubscriptionGetCouponCodeDiscountParams = {
      couponCode: this.couponCode,
      periodTypeId: this.managedSubscription.periodTypeId,
      subscriptionLevelId: this.managedSubscription.subscriptionLevelId,
      subscriptionTypeId: this.managedSubscription.subscriptionTypeId,
      subscriptionType: this.managedSubscription.isXmla ? 'x' : 'i',
    };

    this.subscriptionService
      .subscriptionGetCouponCodeDiscount(req)
      .subscribe((result) => {
        if (result > 0) {
          this.orderDiscount = result;
          this.orderTotalDue = this.orderPrice - this.orderDiscount;
          this.couponCodeError = "Coupon Applied";
        } else {
          this.couponCodeError = "Invalid Coupon Code";
        }
      });
  }

  processPayment() {
    if (this.validateForm()) {
      this.processingCreditCard = true;

      if (this.renewingSubscription || this.activatingSubscription) {
        var renewViewModel: SubscriptionRenewViewModel = {
          autoRenew: this.autoRenew && this.orderPaymentMethod === 'CreditCard',
          subscriptionId: this.subscriptionId,
          orderPaymentMethod: this.orderPaymentMethod,
          poNumber: this.poNumber,
          couponCode: this.couponCode
        };

        this.subscriptionService
          .subscriptionRenewSubscription(renewViewModel)
          .subscribe(
            (trackingId) => {
              if (!trackingId.success) {
                console.log(trackingId.errorMessage);
              } else {
                if (this.orderPaymentMethod === "Invoice") {
                  this.donePurchasing = true;
                } else {
                  var fullUrl =
                    trackingId.requestUrl +
                    "&ACCT=" +
                    this.ccNumber +
                    "&EXPDATE=" +
                    this.ccExpirationMonth +
                    this.ccExpirationYear +
                    "&CVV2" +
                    this.ccCvv;
                  //var payPalWindow = window.open(fullUrl, '_blank');
                  this.payPalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                    fullUrl
                  );

                  var trackWait = interval(5000).subscribe((val) => {
                    this.subscriptionService
                      .subscriptionTrackSubscriptionPayment(trackingId)
                      .subscribe((trackingResult) => {
                        if (trackingResult.completed) {
                          this.processingCreditCard = false;
                          trackWait.unsubscribe();
                          //payPalWindow.close();

                          if (trackingResult.success) {
                            this.donePurchasing = true;
                            this.processingCreditCard = false;
                          } else {
                            MessageDialogComponent.showDialog(
                              this.dialog,
                              "Error Processing",
                              trackingResult.errorMessage
                            );
                          }
                        }
                      });
                  });
                }
              }
            },
            (error) => {
              console.log(error);
              this.processingCreditCard = false;
            }
          );
      } else {
        if (this.managedSubscription.autoRenew) {
          var updateRequest: SubscriptionService.SubscriptionUpdateAutoRenewCardParams = {
            cc: this.ccNumber,
            ccv: this.ccCvv.toString(),
            expMonth: this.ccExpirationMonth.toString(),
            expYear: this.ccExpirationYear.toString(),
            subscriptionId: this.subscriptionId,
          };

          this.subscriptionService
            .subscriptionUpdateAutoRenewCard(updateRequest)
            .subscribe(
              (result) => {
                if (result) {
                  this.processingCreditCard = false;
                  this.donePurchasing = true;
                } else {
                  MessageDialogComponent.showDialog(
                    this.dialog,
                    "Error Processing",
                    "Error updating credit card."
                  );
                  this.processingCreditCard = false;
                }
              },
              (error) => {
                console.log(error);
                this.processingCreditCard = false;
              }
            );
        } else {
          this.processingCreditCard = false;
        }
      }
    }
  }
}
